import {Resource, ResourceType} from "./Resource";
import Factory from "./Factory";

export default class ResourceManager {
    protected resourceFactory: Factory;
    protected loadedResources: Resource[] = [];

    private static normalizeResourceUrl(url: string) {
        return url.replace(/^http.?:\/\//, '//');
    }

    constructor(resourceFactory: Factory) {
        this.resourceFactory = resourceFactory;
    }

    init() {
        this.initLoadedStyles();
    }

    add(type: ResourceType, url: string|string[], callback: (success: boolean) => void = void(0)) {

        let executeCallback = (success: boolean) => {
            if (callback) {
                return callback(success);
            }
        };

        let promises: Promise<void>[] = [];
        let sources: string[] = [];

        if (typeof url === 'string') {
            sources.push(url);
        } else {
            sources = url;
        }

        sources.forEach(source => {
            let resource: Resource = this.resourceFactory.create(type, source);

            if (!this.isResourceLoaded(resource)) {
                let promise = resource.load().then(() => {
                    this.loadedResources.push(resource);
                });

                promises.push(promise);
            }
        });

        Promise.all(promises)
            .then(() => {
                executeCallback(true);
                })
            .catch(() => {
                executeCallback(false);
            });
    }

    private isResourceLoaded(resource: Resource) {
        return this.loadedResources.some(loaded => { return resource.equals(loaded); });
    }

    private initLoadedStyles() {
        Array.prototype.slice.call(window.document.styleSheets).forEach( (style: CSSStyleSheet) => {
            if (style.href && style.href.length) {
                let resource = this.resourceFactory.create(
                    ResourceType.Css,
                    ResourceManager.normalizeResourceUrl(style.href)
                );
                this.loadedResources.push(resource);
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/resources/Manager.ts
 **/